import {Store,Module,ActionContext, MutationTree} from 'vuex'
import ListState from './list-state'
import Ajax from '../../lib/ajax'
import PageResult from '@/store/entities/page-result';
import Util from '../../lib/util'

export default class ListModule<T extends ListState<U>,R,U> implements Module<ListState<U>,R>{
    namespaced = true;
    state={  
        totalCount:0,
        currentPage:1,
        pageSize: 5,  
        list:new Array<U>(),
        loading: false,
        editModel: null
    };
    base_actions = {
        async getAll(context: ActionContext<T, any>, payload: any) {
            if (context.state.loading) return context.state.list;
            context.state.loading = true;
            let reponse = await Ajax.get('/api/' + (context.state as any).path, { params: payload.data }).catch(e => {
                context.state.loading = false;
                return Promise.reject(e);
            });
            context.state.loading = false;
            if (typeof reponse.data.result == 'object' && !Array.isArray(reponse.data.result)) {
                let page = reponse.data.result as PageResult<U>;
                context.state.totalCount = page.total;
                context.state.list = page.data;
            } else {
                context.state.totalCount = reponse.data.result.length;
                context.state.list = reponse.data.result;
            }
            return context.state.list;
        },
        async create(context: ActionContext<T, any>, payload: any) {
            context.state.loading = true;
            let response = await Ajax.post('/api/' + (context.state as any).path, payload.data).catch(e => {
                context.state.loading = false;
                return Promise.reject(e);
            });
            context.state.loading = false;
            if (context.state.loaded) {
                context.state.activeList.push(response.data.result);
            }
            return response.data.result;
        },
        async update(context: ActionContext<T, any>, payload: any) {
            context.state.loading = true;
            let response = await Ajax.put('/api/' + (context.state as any).path + '/' + payload.data.id, payload.data).catch(e => {
                context.state.loading = false;
                return Promise.reject(e);
            });
            context.state.loading = false;
            if (context.state.loaded) {
                context.state.activeList.forEach((item:any, k) => {
                    if (item.id == payload.data.id)
                        item = Util.extend(item, payload.data);
                });
            }
            return response.data.result;                
        },
        async delete(context: ActionContext<T, any>, payload: any) {
            context.state.loading = true;
            let id = payload.data.id;
            await Ajax.delete('/api/' + (context.state as any).path + '/' + id).catch(e => {
                context.state.loading = false;
                return Promise.reject(e);
            });
            context.state.loading = false;
            if (context.state.activeList != undefined && context.state.activeList != null && context.state.activeList.length > 0) {
                context.state.activeList = context.state.activeList.filter((item: any) => {
                    return item.id !== id;
                });
            }
        },
        async get(context: ActionContext<T, any>, payload: any) {
            if (payload.id == undefined) return {};
            let existing = context.state.list.filter((item: any) => {
                return item.id == payload.id;
            });

            let existing2 = [];
            if (context.state.activeList != undefined) {
                existing2 = context.state.activeList.filter((item: any) => {
                    return item != null && item.id == payload.id;
                });
            }

            if (existing.length > 0) return existing[0];            
            if (existing2.length > 0) return existing2[0];            

            context.state.loading = true;
            let response = await Ajax.get('/api/' + (context.state as any).path + '/' + payload.id).catch(e => {
                context.state.loading = false;
                return Promise.reject(e);
            });

            let item = response.data.result as U;
            if (context.state.activeList != undefined) 
                context.state.activeList.push(item);
            context.state.loading = false;
            return item;
        },
        async getAllActive(context: ActionContext<T, any>, payload: any) {
            let force = false;
            if (payload.data != undefined && payload.data['force'] == true) {
                force = true;
                context.state.activeList = [];
            }
            if ((context.state.activeList != undefined && context.state.activeList.length > 0) || (context.state.loading && !force)) return true;
            let params = (payload.data == undefined ? {} : payload.data);
            delete params['force'];
            context.state.loading = true;
            let reponse = await Ajax.get('/api/' + (context.state as any).path, { params: params}).catch(e => {
                context.state.loading = false;
                return Promise.reject(e);
            });
            context.state.activeList = reponse.data.result;
            context.state.loaded = true;
            context.state.loading = false;
        },
        async querySearch(context: ActionContext<T, any>, payload: any) {
            if (payload.data.query == null || payload.data.query == 'null') return [];
            if (context.state.activeList != undefined && context.state.activeList.length > 0) {
                let result = context.state.activeList.filter((item: any) => {
                    return item != null && (item[payload.data.filter].toUpperCase().indexOf(payload.data.query.toUpperCase()) >= 0);
                });

                if (result.length > 0)
                    return result;
            }
            //if (context.state.loading) return context.state.activeList;
            context.state.loading = true;
            let reponse = await Ajax.get('/api/' + (context.state as any).path + '/query-search', { params: payload.data }).catch(e => {
                context.state.loading = false;
                return Promise.reject(e);
            });
            context.state.activeList = reponse.data.result;
            context.state.loading = false;
            return reponse.data.result;
        }
    };
    base_mutations = {
        setCurrentPage(state: T, page: number) {
            state.currentPage = page;
        },
        setPageSize(state: T, pagesize: number) {
            state.pageSize = pagesize;
        },
        edit(state: T, model: U) {
            state.editModel = model;
        },
        view(state: T, model: U) {
            state.editModel = model;
        },
        new(state: T, model: U) {
            state.editModel = Object.assign({});
        },
        setList(state: T, list: any) {
            if (list == null) list = [];
            state.list = list;
            state.totalCount = state.list.length;
        },
        setActiveList(state: T, list: any) {
            if (list == null) list = [];
            (state as any).activeList = list;
        }
    }
}